export default {options:{version:1},validator:{},children:[{options:{key:'provides',type:'value'}},{options:{key:'countries',type:'value'}}]}